// extracted by mini-css-extract-plugin
export default {"container":"style_container__agh-k","form":"style_form__7IjWe"};